<button
  type="button"
  class="btn btn-sm"
  (click)="goBack()"
>
  <i class="fas fa-arrow-left text-primary"></i>
</button>